// extracted by mini-css-extract-plugin
module.exports = {"base":"InputNote_base__1HRWW","Text":"InputNote_Text__tJp_6","Container":"InputNote_Container__3YrDQ","TextContainer":"InputNote_TextContainer__3CdEB"};